'use client'

import ErrorPage from "@/app/components/ErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  return (
    <ErrorPage error={error} buttonClick={reset} />
  )
}
